import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { syncAppViewportHeight } from "./lib/viewport";
import "./styles.css";

syncAppViewportHeight();

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
